var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBarsBlocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14087_155255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7152 0.0908203L-0.151367 16.9574L-1 16.1087L15.8665 -0.757812L16.7152 0.0908203Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0003H2.4987L4.86003 13.639V14.806H7.41244V12.3037H6.19531L7.38965 11.1094H7.41244L7.41211 11.0866L8.58757 9.91146V11.1094H11.109V8.58789H9.91146L11.0863 7.41244L11.109 7.41276V7.38997L12.3034 6.19564V7.41276H14.8057V4.89128H13.6081L14.8024 3.69694H14.8057V3.69336L16 2.49902V16.0003ZM8.58757 14.806H11.109V12.3037H8.58757V14.806ZM12.3034 14.806H14.8057V12.3037H12.3034V14.806ZM12.3034 11.1094H14.8057V8.58789H12.3034V11.1094Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0332 6.50033H3.66667V8.18685H5.34668L4.34668 9.18685H2.66667V5.50033H8.0332L7.0332 6.50033Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 2.86686L9.01335 4.52018H0V0.833659H10.6667V2.86686ZM1 3.52018H9.66667V1.83366H1V3.52018Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14087_155255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarsBlocks);
export default __webpack_public_path__ + "static/media/icon--bars-blocks.9a1e15e7006410b7c1c3fd5d2b30bb9d.svg";
export { ForwardRef as ReactComponent };